import { Component, OnInit } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';

import loans from 'assets/data/product-shelf-master/loans';
import { pathUrl } from '../../configs';
import { FLOW_STATE, ILoanProduct } from '../../core/interfaces';
import { HttpClient } from '@angular/common/http';
import { JsInterfaceService } from '../../core/services/shared/js-interface.service';
import {
  CustomDimensions,
  DeeplinkBody,
  EventGATagging,
} from '../../core/interfaces/js-interface.interface';
import { LoanProductService } from '../../core/services/loan-product/loan-product.service';
import { HttpService } from '@web-di-ld/apps/http';
import { take } from 'rxjs/operators';
import { LOAN_PRODUCT_TYPE } from '../../core/constant/base.enum';
import { CustomerService } from '../../core/services/loan-product/customer.service';
import { FlowService } from '../../core/services/shared/flow-service.service';
import { UiLoadingService } from 'libs/apps/http/src/lib/ui-loading.service';

@Component({
  selector: 'web-di-ld-loan-product-shelf',
  templateUrl: './loan-product-shelf.component.html',
  styleUrls: ['./loan-product-shelf.component.scss'],
})
export class LoanProductShelfComponent implements OnInit {
  public loanProductList!: Array<ILoanProduct>;

  constructor(
    private translocoService: TranslocoService,
    public http: HttpClient,
    private jsInterfaceService: JsInterfaceService,
    private loanProductService: LoanProductService,
    private httpService: HttpService,
    private customerService: CustomerService,
    private flowService: FlowService,
    public uiLoadingService: UiLoadingService
  ) {}

  public setActiveLang(lang: string) {
    this.translocoService.setActiveLang(lang);
  }

  public async onNavigateToProduct(product?: ILoanProduct) {
    if (product && product?.productType === LOAN_PRODUCT_TYPE.SMARTMONEY) {
      this.jsInterfaceService.applyLoan({ productType: product?.productType });
    }

    if (product && product?.productType !== LOAN_PRODUCT_TYPE.SMARTMONEY) {
      const productData: DeeplinkBody = {
        productType: product.productType,
        campaignId: product.campaignId,
      };
      const event = {
        action: 'Click',
        category: 'DigitalLending_LoanWebProductShelf',
        label: 'DigitalLending_LoanWebProductShelf_LoanProduct',
        value: null,
      };

      const dimension = [
        {
          key: 'PRODUCT_TYPE',
          value: product.productType,
        },
      ];
      this.gaTagging(event, dimension);
      this.jsInterfaceService.openDeepLink(productData);
    } else if (product) {
      const request = {
        campaignId: product.campaignId,
        productNameEn: product.productNameEn,
        productNameTh: product.productNameTh,
        maxCreditLimit: product.maxCreditLimit,
        minCreditLimit: product.minCreditLimit,
        maxInterestRate: product.maxInterestRate,
        minInterestRate: product.minInterestRate,
      };
      const response = await this.loanProductService.loanOffers(request);
      if (response) {
        const event = {
          action: 'Click',
          category: 'DigitalLending_LoanWebProductShelf',
          label: 'DigitalLending_LoanWebProductShelf_LoanProduct',
          value: null,
        };

        const dimension = [
          {
            key: 'PRODUCT_TYPE',
            value: product.productType,
          },
        ];
        this.gaTagging(event, dimension);
        this.loanProductService.updateLoanOffers(response);
        this.loanProductService.updateLoanProduct(product);
        this.enterFullScreen(pathUrl.loanApply.apply);
      }
    }
  }

  public enterFullScreen(url?: string) {
    this.jsInterfaceService.enterFullScreen(url);
  }

  ngOnInit(): void {
    this.flowService.setFlow(FLOW_STATE.SHELF, FLOW_STATE.SHELF);
    this.getVerifyToken();

    const event = {
      action: 'View',
      category: 'DigitalLending_LoanWebProductShelf',
    };
    this.gaTagging(event);
  }

  async getVerifyToken() {
    if (this.httpService.verifyToken === null) {
      const token = await this.httpService.token$.pipe(take(1)).toPromise();
      const verifyToken = await this.httpService
        .getVerifyToken(token)
        .toPromise();
      this.httpService.verifyToken = verifyToken;
      const lang =
        verifyToken && verifyToken?.data?.language === 'th-TH' ? 'th' : 'en';
      this.setActiveLang(lang);
    }
    const loanResponse = await this.loanProductService.getLoans();
    const loanList =
      loanResponse && loanResponse.offers.length > 0
        ? loanResponse.offers.filter(
            (loan: ILoanProduct) =>
              loan.productType !== LOAN_PRODUCT_TYPE.SMARTMONEY
          )
        : [];
    this.loanProductList = loanList.concat(loans);

    this.loanProductList.map((product: ILoanProduct) => {
      if (product.productType !== LOAN_PRODUCT_TYPE.PAYDAY) {
        this.getCustomerDetail(product);
      }
    });
    console.log(this.loanProductList, 'loanProductList');
  }

  async getCustomerDetail(product: ILoanProduct) {
    const customerDetail = await this.customerService.getCustomerDetail(
      product.campaignId
    );
    if (customerDetail) product.customerDetail = customerDetail;
    if (product.productType === LOAN_PRODUCT_TYPE.SMARTMONEY)
      this.customerService.updateCustomerDetail(customerDetail);
    return product;
  }

  public onNavigateToCalculation() {
    const event = {
      action: 'Click',
      category: 'DigitalLending_LoanWebProductShelf',
      label: 'DigitalLending_LoanWebProductShelf_LoanCalculation',
      value: null,
    };

    this.gaTagging(event);
    this.enterFullScreen(pathUrl.loanApply.calculation);
  }

  public onCall() {
    const event = {
      action: 'Click',
      category: 'DigitalLending_LoanWebProductShelf',
      label: 'DigitalLending_LoanWebProductShelf_KrungthaiContactCenter',
      value: null,
    };

    this.gaTagging(event);
    window.open('tel:021111111');
  }

  gaTagging(event: EventGATagging, dimension?: CustomDimensions[]) {
    this.jsInterfaceService.gaTagging(event, dimension);
  }
}
